import { render } from "./dpp-ctacard.vue?vue&type=template&id=f04e89a0"
import script from "./dpp-ctacard.js?vue&type=script&lang=js"
export * from "./dpp-ctacard.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__